import React from 'react';
import { IIconProps } from './IIconProps';

export const AchievementIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 269 108"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				opacity="0.5"
				d="M184.445 61.9094C181.658 58.0804 182.456 52.6553 186.228 49.7919L194.07 60.5647C196.856 64.3936 196.058 69.8188 192.286 72.6821L184.445 61.9094Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.6"
				d="M80.7884 16.5055C78.2452 13.0115 78.974 8.06088 82.4161 5.44799L89.5713 15.2784C92.1145 18.7724 91.3857 23.723 87.9436 26.3359L80.7884 16.5055Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.1"
				d="M4.68463 25.5287C2.2635 28.8551 2.95731 33.5682 6.2343 36.0557L13.0463 26.6969C15.4674 23.3705 14.7736 18.6574 11.4966 16.1699L4.68463 25.5287Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.5"
				d="M147.535 91.5863C150.894 88.226 156.283 88.2815 159.572 91.7102L150.222 101.064C146.864 104.424 141.474 104.369 138.185 100.94L147.535 91.5863Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.8"
				d="M133.942 15.3026C131.985 17.9239 128.306 18.4196 125.725 16.4097L131.227 9.04054C133.184 6.41923 136.863 5.92357 139.444 7.93345L133.942 15.3026Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.3"
				d="M85.4788 74.9603C90.2173 73.6589 95.0731 76.4561 96.3245 81.2081L83.5169 84.7256C78.7784 86.0271 73.9226 83.2299 72.6712 78.4779L85.4788 74.9603Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.3"
				d="M205.862 40.6743C209.082 39.7902 212.381 41.6905 213.231 44.9189L204.53 47.3087C201.31 48.1928 198.012 46.2925 197.161 43.0641L205.862 40.6743Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.3"
				d="M51.5037 96.7202C50.4812 93.603 52.1687 90.2151 55.2728 89.1533L58.2005 98.079C59.223 101.196 57.5356 104.584 54.4315 105.646L51.5037 96.7202Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.1"
				d="M223.218 91.3649C226.903 95.4102 226.675 101.745 222.707 105.514L212.749 94.5819C209.065 90.5366 209.293 84.202 213.261 80.4332L223.218 91.3649Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.1"
				d="M263.424 38.8949C261.718 42.4088 257.511 43.8275 254.026 42.0636L258.721 32.3892C260.427 28.8753 264.634 27.4567 268.119 29.2206L263.424 38.8949Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.1"
				d="M170.014 33.2796C168.308 36.7935 164.101 38.2122 160.616 36.4483L165.311 26.7739C167.016 23.26 171.224 21.8414 174.709 23.6053L170.014 33.2796Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.1"
				d="M51.4701 24.5852C54.6666 27.0173 55.3387 31.6193 52.9714 34.8641L44.4416 28.3738C41.2452 25.9417 40.573 21.3397 42.9404 18.0949L51.4701 24.5852Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.3"
				d="M52.2334 66.8201L45.9859 62.8757C45.9859 62.8757 50.6498 58.643 52.7621 55.2486C55.0258 51.6108 56.8008 45.0113 56.8008 45.0113L63.0483 48.9557C61.8328 55.2433 59.4865 61.2579 52.2334 66.8201Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.2"
				d="M180.072 4.44868L186.184 0.655678C186.184 0.655678 187.719 6.65875 189.67 10.0303C191.761 13.6436 196.584 18.1327 196.584 18.1327L190.472 21.9257C185.666 18.0703 181.593 13.3335 180.072 4.44868Z"
				fill="#25D9B8"
			/>
			<path
				opacity="0.2"
				d="M28.3136 78.3181L30.4355 82.5678C30.4355 82.5678 26.5323 83.2972 24.2872 84.4307C21.8812 85.6456 18.7838 88.6352 18.7838 88.6352L16.6619 84.3856C19.3543 81.377 22.5732 78.8978 28.3136 78.3181Z"
				fill="#25D9B8"
			/>
			<path
				d="M138.637 49.03H111.555L125.575 35.6901L138.637 49.03Z"
				fill="#6FF5DC"
			/>
			<path
				d="M138.641 49.03L124.967 34.9787L151.179 34.3561L151.789 36.2237L138.641 49.03Z"
				fill="#66EEDE"
			/>
			<path
				d="M112.163 48.6743L98.7523 35.6012L99.3619 34.3561L125.574 34.9787L112.163 48.6743Z"
				fill="#66EEDE"
			/>
			<path
				d="M112.513 49.03H89L98.1438 35.6901L112.513 49.03Z"
				fill="#60E1DA"
			/>
			<path
				d="M138.64 49.03H162.152L153.009 35.6901L138.64 49.03Z"
				fill="#60E1DA"
			/>
			<path
				d="M138.986 49.2968H112.164L125.575 76.6881L138.986 49.2968Z"
				fill="#5DE7CD"
			/>
			<path
				d="M111.206 49.03H89L125.575 79.8007V75.443L111.206 49.03Z"
				fill="#4BD2CB"
			/>
			<path
				d="M138.641 49.03H161.543L124.968 79.8007V76.6881L138.641 49.03Z"
				fill="#4BD2CB"
			/>
			<path
				d="M139.449 48.679L125.575 75.9321L111.702 48.679M139.449 48.679L152.688 36.15M139.449 48.679L125.575 34.9787L111.702 48.679M111.702 48.679L98.1467 35.8508M89 48.679H162.151M99.1931 34.3561L89 48.9147L125.575 79.7118L162.151 48.9147L151.358 34.3561H99.1931Z"
				stroke="#25D9B8"
			/>
		</svg>
	);
};
